'use client';

import SweepLight from '@/assets/svg/sweep-light.svg';

const CARD_COUNT = 5;

function ForYouCardRowSkeleton() {
    return (
        <article className='relative flex w-full items-center gap-[12px] overflow-hidden'>
            {/* 封面占位（与 ForYouCardList 一致 80×107） */}
            <div className='h-[107px] w-[80px] shrink-0 animate-pulse rounded-[8px] bg-[#EBE9EE]' />
            <div className='w-full'>
                {/* 标题行 */}
                <div className='h-[14px] w-full animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                {/* 描述两行（Figma 约 12px 高，次行宽约 209） */}
                <div className='mt-[9px] flex flex-col gap-[4px]'>
                    <div className='h-[12px] w-full animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                    <div className='h-[12px] w-[209px] max-w-full animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                </div>
                {/* 标签占位（Figma 单 pill 约 64×20） */}
                <div className='mt-[10px] flex flex-wrap items-center gap-[4px]'>
                    <div className='h-[20px] w-[64px] shrink-0 animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                    <div className='h-[20px] w-[52px] shrink-0 animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                </div>
            </div>
            {/* 扫光动画见 src/styles/animate.scss */}
            <span className='animate-skeleton-sweep-x pointer-events-none absolute left-0 top-[-10px] block h-[152px] w-[99px] shrink-0'>
                <SweepLight className='size-full' />
            </span>
        </article>
    );
}

export default function ForYouCardSkeleton() {
    return (
        <div className='mt-[12px] space-y-[12px]'>
            {Array.from({ length: CARD_COUNT }, (_row, index) => (
                <ForYouCardRowSkeleton key={index} />
            ))}
        </div>
    );
}
